<template>
  <router-view></router-view>
</template>

<script>
    export default {
        name: "CustomerHome"
    }
</script>

<style scoped>

</style>
